import { useEffect, useState } from "react";
import AdminLayout from "../../../layouts/AdminLayout";
import Modal from "../../../components/ui/Modal";
import Button from "../../../components/ui/Button";
import { EmptyState } from "../../../components/ui/FeedbackStates";
import ResidentBookAmenityModal from "./ResidentBookAmenityModal";
import { getAmenities } from "../../../services/amenityService";
import { getStoredAuthUser } from "../../../services/authService";
import { toast } from "react-toastify";
import styles from "./ResidentAmenities.module.css";
import Skeleton from "../../../components/ui/Skeleton";

const ResidentAmenities = () => {
  const user = getStoredAuthUser();
  const [amenities, setAmenities] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [openModal, setOpenModal] = useState(false);
  const [selectedAmenity, setSelectedAmenity] = useState(null);

  const fetchAmenities = async () => {
    try {
      const data = await getAmenities(user?.society_id || "");
      setAmenities(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error("Error fetching amenities:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAmenities();
  }, [user]);

  return (
    <AdminLayout title="Amenities">
      <div className={styles.pageContainer}>
        <div className={styles.header}>
          <h2 className={styles.pageTitle}>Society Amenities</h2>
          <p className={styles.pageSubtitle}>Browse and book available amenities in your society.</p>
        </div>

        {loading ? (
          <Skeleton variant="list" count={3} />
        ) : amenities.length === 0 ? (
          <EmptyState
            title="No Amenities Found"
            description="Your society hasn't added any amenities yet."
          />
        ) : (
          <div className={styles.grid}>
            {amenities.map((amenity) => (
              <div key={amenity.amenity_id} className={styles.card}>
                <div className={styles.cardContent}>
                  <h3 className={styles.amenityTitle}>{amenity.name}</h3>
                  <p className={styles.amenityDesc}>
                    {amenity.description || "No description provided."}
                  </p>
                  
                  <div className={styles.details}>
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>Fee:</span>
                      <span>{Number(amenity.booking_fee) === 0 ? "Free" : `₹${amenity.booking_fee}`}</span>
                    </div>
                    <div className={styles.detailRow}>
                      <span className={styles.detailLabel}>Timings:</span>
                      <span>
                        {amenity.opening_time ? new Date(amenity.opening_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : "06:00"} 
                        {" - "} 
                        {amenity.closing_time ? new Date(amenity.closing_time).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' }) : "22:00"}
                      </span>
                    </div>
                  </div>
                </div>
                
                <div className={styles.cardFooter}>
                  <Button 
                    onClick={() => {
                      setSelectedAmenity(amenity);
                      setOpenModal(true);
                    }}
                  >
                    Book Now
                  </Button>
                </div>
              </div>
            ))}
          </div>
        )}

        <Modal
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          title={`Book ${selectedAmenity?.name || "Amenity"}`}
        >
          {selectedAmenity && (
            <ResidentBookAmenityModal
              amenity={selectedAmenity}
              onClose={() => setOpenModal(false)}
              onSuccess={() => {
                setOpenModal(false);
                toast.success("Amenity booked successfully! Awaiting approval.");
              }}
            />
          )}
        </Modal>
      </div>
    </AdminLayout>
  );
};

export default ResidentAmenities;
